export const validation = {
  documentTypeRequired: "Please enter a document type",
  reason: "Please enter a reason",
  discountAmount: "Please enter discount amount",
};
